import { Flame, Compass, Trophy } from "lucide-react";

const items = [
  {
    icon: Flame,
    title: "Daily discipline rituals",
    body: "30 micro-protocols you can run in under 25 minutes — built to compound, not consume your day.",
  },
  {
    icon: Compass,
    title: "Mindset recalibration",
    body: "Replace identity-level limits with the 3x standard. Become the person your goals already require.",
  },
  {
    icon: Trophy,
    title: "Track-able outcomes",
    body: "Each chapter ships with a measurable win. By Day 30 you have evidence, not affirmations.",
  },
];

export default function ValueProps() {
  return (
    <section
      data-testid="value-props"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37]/80">
            Why this book exists
          </p>
          <h2 className="font-serif-display mt-4 text-4xl sm:text-5xl text-white leading-[1.05] tracking-tight">
            Stop reading <em className="gold-text">about</em> growth.
            <br />
            Start <span className="text-white">compounding it.</span>
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {items.map(({ icon: Icon, title, body }, i) => (
            <div
              key={i}
              data-testid={`value-card-${i}`}
              className="group relative p-8 rounded-2xl bg-[#121212] border border-white/5 hover:border-[#d4af37]/30 transition-all duration-500 hover:translate-y-[-4px]"
            >
              <div className="w-12 h-12 rounded-xl bg-[#d4af37]/10 border border-[#d4af37]/20 flex items-center justify-center mb-6 group-hover:bg-[#d4af37]/15 transition-colors">
                <Icon className="w-5 h-5 text-[#d4af37]" />
              </div>
              <h3 className="font-serif-display text-2xl text-white">
                {title}
              </h3>
              <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
                {body}
              </p>
              <div className="absolute bottom-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-[#d4af37]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
